/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const SECTION_OPTION = gql`
  query GetCostumeTypes($filter: CostumeTypeFilterInput) {
    getCostumeTypes(filter: $filter) {
      content {
        id
        displayName {
          sectionID
          name
        }
        partitions {
          defaultInvites
          sectionID
          sectionSpecificInvites
          specialInvites
        }
        name
        code
        description
        id
        images
        img1
        img2
        isMandatory
        isSingleFeature
        isVisible
        name
        price
        minDownPayment
        costumeFeatures {
          alias
          basePrice
          code
          currency
          desc
          id
          images
          img1
          isLabel
          img2
          isMandatory
          isCommon
          isSingleAttribute
          isBase
          isVisible
          maxInventory
          name
          costumeAttributes {
            desc
            dynaInventory
            id
            isLabel
            isMandatory
            isDynamic
            isSingleVal
            isVisible
            name
            images
            costumeValues {
              currency
              desc
              id
              inventory
              isMandatory
              isLabel
              isVisible
              disclaimer
              name
              topupPrice
              minDownPayment
              position
            }
          }
          isCommon
          featurePosition
          section {
            id
            name
          }
          isSingleSection
        }
        isSingleSection
      }
    }
  }
`;
